
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punrtooutstationcab() {



    const cardData =
    {
        keyword: 'Pune to Outstation Cab',
        heading: 'Meghana Cab: Pune to Outstation Cab',
        headingDescription: 'Meghana Cab offers Pune to Outstation Cab services, delivering safe, comfortable, and affordable travel for your long-distance journeys. Whether you are heading to a hill station, religious destination, coastal retreat, or a business trip, our fleet of well-maintained cabs and trained drivers ensure a smooth and enjoyable ride. Choose from a range of vehicles to match your travel needs, enjoy flexible booking, transparent pricing, and 24/7 customer support. Book your Pune to Outstation Cab with Meghana Cab and travel worry-free across Maharashtra and beyond.',


        top: 'Top Places to Visit in Pune Outstation with Meghana Cab',

"topPlaces": [
  {
    "title": "Lonavala",
    "description": "A popular hill station located about 65 km from Pune, Lonavala is renowned for its misty hills, scenic valleys, and lush greenery, especially during the monsoon. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla Caves. It’s ideal for weekend getaways and romantic escapes."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Situated around 120 km from Pune, Mahabaleshwar is a picturesque hill town in the Western Ghats. Known for its strawberry farms, viewpoints like Arthur’s Seat, Wilson Point, and ancient temples, the town is a favorite for nature lovers and honeymooners alike."
  },
  {
    "title": "Alibaug",
    "description": "Approximately 140 km from Pune, Alibaug offers a coastal retreat with serene beaches, old forts, and a relaxed atmosphere. Key spots include Alibaug Beach, Kolaba Fort, and Varsoli Beach. It’s perfect for a short break from city life and a dose of sea breeze."
  },
  {
    "title": "Lavasa",
    "description": "Located about 60 km from Pune, Lavasa is a modern planned city inspired by Italian architecture. Surrounded by hills and a large lake, it’s an ideal place for boating, cycling, and lakeside walks. The colorful buildings and promenade make it a popular photo spot."
  },
  {
    "title": "Nashik",
    "description": "Roughly 210 km from Pune, Nashik is a spiritual and wine tourism destination. Visit the famous Trimbakeshwar Temple, Sula Vineyards, and Panchavati. The city blends religious heritage with modern vineyards, offering diverse experiences to travelers."
  },
  {
    "title": "Shirdi",
    "description": "Located 190 km from Pune, Shirdi is a major pilgrimage town known for the revered Sai Baba Temple. Devotees from across the country visit year-round. Besides the main temple, other attractions include Dwarkamai, Chavadi, and the Sai Heritage Village."
  },
  {
    "title": "Goa",
    "description": "At a distance of around 450 km, Goa is one of the most sought-after long weekend destinations from Pune. Known for its pristine beaches, vibrant nightlife, Portuguese heritage, and seafood, Goa offers a perfect blend of relaxation and fun."
  },
  {
    "title": "Kolhapur",
    "description": "Located around 235 km from Pune, Kolhapur is famous for the Mahalakshmi Temple, historical forts, and its unique cuisine. The city is also known for Kolhapuri chappals and traditional jewelry. It’s a blend of culture, tradition, and spirituality."
  },
  {
    "title": "Bhimashankar",
    "description": "Situated 110 km from Pune, Bhimashankar is one of the 12 Jyotirlingas of Lord Shiva. Nestled in the Sahyadri Hills, the site offers both spiritual value and a scenic trekking experience. The surrounding wildlife sanctuary is rich in flora and fauna."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "Around 120 km from Pune, Satara is a historical town surrounded by forts and valleys. The nearby Kaas Plateau, also known as the 'Valley of Flowers of Maharashtra,' blooms with seasonal wildflowers post-monsoon and is a UNESCO biodiversity hotspot."
  }
],

"services": [
    {
        "name": "Outstation Cab Booking from Pune",
        "description": "Book reliable and comfortable outstation cabs from Pune with Meghana Cab. Whether you're planning a short getaway or a long-distance trip, we offer well-maintained vehicles, professional drivers, and flexible packages for every travel need."
    },
    {
        "name": "Pune to Any City Outstation Taxi",
        "description": "Travel from Pune to any city across Maharashtra or India with our dependable outstation taxi service. Enjoy hassle-free journeys with fixed pricing, clean vehicles, and experienced drivers who ensure a safe and smooth ride."
    },
    {
        "name": "One Way Outstation Cab Pune",
        "description": "Need a drop-off in another city? Book a one-way outstation cab from Pune and save on travel costs. Meghana Cab offers a wide fleet of vehicles with timely pickup and convenient booking options for one-way trips."
    },
    {
        "name": "Round Trip Outstation Cabs Pune",
        "description": "Choose our round trip outstation cab services from Pune for a complete travel solution. Ideal for weekend getaways, business meetings, or family trips, our round trip packages are flexible, cost-effective, and come with reliable support."
    },
    {
        "name": "SUV Rental for Outstation Pune",
        "description": "Planning a group or family outing? Our spacious SUVs are perfect for outstation travel from Pune. Enjoy ample legroom, luggage space, and a powerful ride for long highway journeys with Meghana Cab."
    },
    {
        "name": "Sedan Outstation Cabs from Pune",
        "description": "For comfortable and budget-friendly travel, book our sedan cabs for outstation journeys from Pune. Ideal for small families or solo travelers, our sedans offer AC comfort and clean interiors for a relaxed ride."
    },
    {
        "name": "Affordable Outstation Travel from Pune",
        "description": "Meghana Cab provides affordable outstation travel options from Pune without compromising on service quality. Get the best prices, well-maintained vehicles, and courteous drivers for your journey."
    },
    {
        "name": "24/7 Outstation Taxi Service Pune",
        "description": "Travel at any time with our 24/7 outstation taxi service from Pune. Whether it’s an early morning pickup or a late-night drop, Meghana Cab is available round-the-clock for all your intercity travel needs."
    },
    {
        "name": "Pune to Goa Cab",
        "description": "Book a cab from Pune to Goa with Meghana Cab for a scenic and enjoyable coastal road trip. Choose from sedans, SUVs, or premium vehicles for your holiday travel, and enjoy professional service throughout the journey."
    },
    {
        "name": "Pune to Nashik Outstation Taxi",
        "description": "Travel from Pune to Nashik comfortably with Meghana Cab’s outstation taxi. Perfect for religious trips, vineyard tours, or business visits, our cabs ensure on-time service and a pleasant ride."
    },
    {
        "name": "Online Outstation Booking Pune",
        "description": "Enjoy the convenience of online outstation cab booking from Pune with Meghana Cab. Select your destination, vehicle type, and schedule—all within minutes. Safe, easy, and fully digital process."
    },
    {
        "name": "Weekend Outstation Cab Pune",
        "description": "Planning a weekend trip out of Pune? Meghana Cab offers special weekend cab packages for popular destinations like Lonavala, Mahabaleshwar, Shirdi, and more—perfect for quick getaways with friends or family."
    },
    {
        "name": "Pune to Shirdi Outstation Taxi",
        "description": "Book a cab from Pune to Shirdi with Meghana Cab for a smooth and spiritual journey. Enjoy reliable service, AC comfort, and well-trained drivers familiar with the route and local stops."
    },
    {
        "name": "Pune to Mahabaleshwar Outstation Cab",
        "description": "Escape to the hills with our Pune to Mahabaleshwar cab service. Meghana Cab offers scenic rides in clean vehicles with flexible return options and courteous chauffeurs for a memorable hill station trip."
    },
    {
        "name": "Outstation Road Trips from Pune",
        "description": "Experience the freedom of the open road with Meghana Cab’s outstation road trip packages from Pune. Customize your route, vehicle type, and itinerary—perfect for friends, family, or solo adventures."
    }
],

"tableData": [
    ["Outstation Cab Booking from Pune", "Pune to Any City Outstation Taxi"],
    ["One Way Outstation Cab Pune", "Round Trip Outstation Cabs Pune"],
    ["SUV Rental for Outstation Pune", "Sedan Outstation Cabs from Pune"],
    ["Affordable Outstation Travel from Pune", "24/7 Outstation Taxi Service Pune"],
    ["Pune to Goa Cab", "Pune to Nashik Outstation Taxi"],
    ["Online Outstation Booking Pune", "Weekend Outstation Cab Pune"],
    ["Pune to Shirdi Outstation Taxi", "Pune to Mahabaleshwar Outstation Cab"],
    ["Outstation Road Trips from Pune", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Outstation Cab Services",
        "WhyChoosedescription": "Meghana Cab offers dependable outstation cab services from Pune to destinations across Maharashtra and beyond. Whether you're heading to a nearby hill station, a pilgrimage site, or another city, our cabs ensure a safe, smooth, and timely journey tailored to your travel needs."
    },
    {
        "WhyChooseheading": "Multiple Vehicle Options for All Group Sizes",
        "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, tempo travellers, or luxury cars based on your group size and comfort preferences. Each vehicle is spacious, air-conditioned, and well-maintained for long-distance travel."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Outstation Expertise",
        "WhyChoosedescription": "Our drivers are trained for long-distance and intercity routes. They’re familiar with road conditions, traffic patterns, and best stopover points, ensuring a safe and pleasant journey for every passenger."
    },
    {
        "WhyChooseheading": "Customizable Travel Plans & Flexible Itineraries",
        "WhyChoosedescription": "Whether it’s a one-way trip, round trip, or multi-city tour, Meghana Cab lets you customize your travel itinerary with planned stopovers, sightseeing options, and tailored drop-off locations."
    },
    {
        "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our Pune to outstation cab services offer competitive, transparent pricing. You pay only for what you book—no hidden tolls, parking charges, or surprise add-ons at the end of the trip."
    },
    {
        "WhyChooseheading": "Clean, Safe, and Sanitized Cabs",
        "WhyChoosedescription": "Your safety is our priority. All our cabs undergo routine maintenance, regular cleaning, and sanitization. Vehicles are GPS-enabled, and seat belts are provided for all passengers."
    },
    {
        "WhyChooseheading": "24/7 Outstation Cab Availability",
        "WhyChoosedescription": "Meghana Cab operates day and night to serve your outstation travel requirements. Whether you're planning a weekend getaway or an emergency trip, we’re available 24/7 with quick response and support."
    },
    {
        "WhyChooseheading": "Easy Booking & Real-Time Support",
        "WhyChoosedescription": "Book your Pune to outstation cab in minutes via our website, mobile app, or customer helpline. Get real-time booking updates, driver details, and live tracking for added peace of mind."
    }
]








































    }

const faqData = [
    {
        question: "How can I book an outstation cab from Pune with Meghana Cab?",
        answer: "You can easily book a Pune to outstation cab by calling Meghana Cab at +91 9075462128 or using our website."
    },
    {
        question: "What destinations do you cover for outstation cabs from Pune?",
        answer: "We cover popular destinations around Pune including Mumbai, Lonavala, Nashik, Goa, and many more."
    },
    {
        question: "What types of vehicles are available for Pune to outstation trips?",
        answer: "We offer sedans, SUVs, and tempo travellers based on your group size and luggage requirements."
    },
    {
        question: "Can I book a one-way or round-trip outstation cab from Pune?",
        answer: "Yes, both one-way and round-trip outstation cab services are available."
    },
    {
        question: "What is included in the Pune to outstation cab fare?",
        answer: "The fare includes driver charges, fuel, tolls, and vehicle maintenance. Additional charges may apply based on your trip."
    },
    {
        question: "Are Meghana Cab vehicles sanitized and safe for long-distance travel?",
        answer: "Yes, all vehicles are regularly sanitized and maintained to ensure your safety and comfort."
    },
    {
        question: "Is Meghana Cab available 24/7 for outstation bookings?",
        answer: "Yes, our service operates round-the-clock to cater to your travel plans."
    },
    {
        question: "Can I request a driver for the outstation trip?",
        answer: "Yes, all our cabs come with experienced and professional drivers familiar with outstation routes."
    },
    {
        question: "What payment methods are accepted for Pune to outstation cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How can I contact Meghana Cab for Pune to outstation cab service?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune to outstation cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Suresh Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I booked an outstation cab from Pune with Meghana Cab, and the trip was very comfortable and hassle-free.”',
    },
    {
        name: 'Ms. Kavita Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The driver was professional and the vehicle clean. Highly recommend Meghana Cab for outstation trips.”',
    },
];


































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







// ✅ JSON-LD objects (define above your Helmet)
const cabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.meghanacabs.com/pune-to-outstation-cab#service",
  "serviceType": "Pune to Outstation Cab",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com/"
  },
  "areaServed": [
    "Pune","Mumbai","Navi Mumbai","Thane","Lonavala","Mahabaleshwar","Panchgani",
    "Nashik","Kolhapur","Shirdi","Aurangabad","Goa","Ratnagiri","Alibaug","Maharashtra","India"
  ],
  "description": "Book Pune to outstation cabs for one-way and round-trip journeys. Clean AC Sedan & SUV, verified drivers, transparent fares, and 24x7 support for all major routes.",
  "offers": {
    "@type": "AggregateOffer",
    "priceCurrency": "INR",
    "lowPrice": "1499",
    "highPrice": "9999",
    "offerCount": "20",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-outstation-cab"
  },
  "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.9", "ratingCount": 7234 }
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://www.meghanacabs.com/#biz",
  "name": "Meghana Cabs",
  "url": "https://www.meghanacabs.com/",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-outstation-cab.jpg",
  "priceRange": "₹₹",
  "address": { "@type": "PostalAddress", "addressLocality": "Pune", "addressRegion": "MH", "addressCountry": "IN" },
  "areaServed": ["Pune","Maharashtra","Goa","Karnataka"],
  "openingHoursSpecification": [{
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
    "opens": "00:00", "closes": "23:59"
  }],
  "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "ratingCount": 8049 }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.meghanacabs.com/" },
    { "@type": "ListItem", "position": 2, "name": "Pune to Outstation Cab", "item": "https://www.meghanacabs.com/pune-to-outstation-cab" }
  ]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Which outstation routes do you cover from Pune?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Popular routes include Mumbai, Nashik, Kolhapur, Shirdi, Mahabaleshwar, Lonavala, Aurangabad, Alibaug, Ratnagiri, and Goa. Custom routes are available on request."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer one-way and round-trip bookings?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Choose one-way drops for point-to-point travel or round-trip for multi-day plans with waiting/driver allowance clearly mentioned."
      }
    },
    {
      "@type": "Question",
      "name": "What cab types can I book?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "AC Sedan, SUV, and premium cars—clean, well-maintained, with verified professional drivers."
      }
    },
    {
      "@type": "Question",
      "name": "Are the fares fixed and transparent?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. You’ll see all-inclusive pricing upfront based on cab type, distance, tolls, and state taxes (if applicable)."
      }
    }
  ]
};

// (Optional but recommended) ItemList to highlight top outstation routes on this page
const popularRoutesSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Popular Outstation Routes from Pune",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Pune to Mumbai Cabs", "url": "https://www.meghanacabs.com/pune-to-mumbai-cabs" },
    { "@type": "ListItem", "position": 2, "name": "Pune to Kolhapur Cab", "url": "https://www.meghanacabs.com/pune-to-kolhapur-cab" },
    { "@type": "ListItem", "position": 3, "name": "Pune to Nashik Cab", "url": "https://www.meghanacabs.com/pune-to-nashik-cab" },
    { "@type": "ListItem", "position": 4, "name": "Pune to Shirdi Cab", "url": "https://www.meghanacabs.com/pune-to-shirdi-cab" },
    { "@type": "ListItem", "position": 5, "name": "Pune to Goa Cabs", "url": "https://www.meghanacabs.com/pune-to-goa-cabs" }
  ]
};







    return (
        <div>

<Helmet>
  <title>Pune to Outstation Cab | One Way & Round Trip Taxi from Pune | Meghana Cabs</title>
  <meta
    name="description"
    content="Book Pune to outstation cab for one-way or round trip. Clean AC Sedan & SUV, verified drivers, transparent fares, and 24x7 support for Mumbai, Nashik, Kolhapur, Shirdi, Goa & more."
  />
  <link rel="canonical" href="https://www.meghanacabs.com/pune-to-outstation-cab" />
  <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />

  {/* Optional meta keywords */}
  <meta
    name="keywords"
    content="Pune to Outstation Cab, Outstation Taxi from Pune, One Way Cab Pune, Round Trip Taxi Pune, Pune to Mumbai Cab, Pune to Nashik Taxi, Pune to Kolhapur Cab, Pune to Shirdi Cab, Pune to Goa Cab"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Pune to Outstation Cab | Meghana Cabs" />
  <meta
    property="og:description"
    content="Outstation cabs from Pune—one-way & round trip with AC Sedan & SUV, transparent fares, 24x7 support."
  />
  <meta property="og:url" content="https://www.meghanacabs.com/pune-to-outstation-cab" />
  <meta property="og:image" content="https://www.meghanacabs.com/assets/images/pune-to-outstation-cab.jpg" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Pune to Outstation Cab | Meghana Cabs" />
  <meta
    name="twitter:description"
    content="Book outstation taxis from Pune—one-way & round trip, AC Sedan & SUV, verified drivers."
  />
  <meta name="twitter:image" content="https://www.meghanacabs.com/assets/images/pune-to-outstation-cab.jpg" />

  {/* JSON-LD */}
  <script type="application/ld+json">{JSON.stringify(cabServiceSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(popularRoutesSchema)}</script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/31.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punrtooutstationcab;